import { render } from "./JourneyScreen.vue?vue&type=template&id=fb4f961c&scoped=true"
import script from "./JourneyScreen.vue?vue&type=script&lang=js"
export * from "./JourneyScreen.vue?vue&type=script&lang=js"

import "./JourneyScreen.vue?vue&type=style&index=0&id=fb4f961c&scoped=true&lang=css"

import exportComponent from "/builds/cloud/messenger/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb4f961c"]])

export default __exports__